module.exports = __webpack_public_path__ + "assets/img/scenePic17.7148ab1a.png";